import Group from "./Group";
import Link from "./Link";
import Single from "./Single";
import List from "./List";
import Notation from "./Notation";
import Fader from "./Fader";
import Preview from "./Preview";

export default {
  Group,
  Link,
  Single,
  List,
  Notation,
  Fader,
  Preview
};
